/**
 * * end of cart upsell block part
 */
$(document).ready(function () {
  const amountFreeProduct = document.querySelector("[data-treshold-product]")
    ? document.querySelector("[data-treshold-product]").getAttribute("data-treshold-product")
    : null;

  var cart_total = $(".gb-totals-total-value").first().text();
  if (amountFreeProduct > 0 && show_progress_bar) {
    // Check if premium-attachment-kit block is present (handles free gifts separately)
    const hasPremiumKit = document.querySelector('.premium-attachment-kit') !== null;
    
    if (hasPremiumKit) {
      console.log("Premium kit detected - skipping auto free gift trigger");
      return;
    }
    
    /*GB! free product added STARTS*/
    setTimeout(function () {
      var cart_total = $(".gb-totals-total-value").first().text();
      if (cart_total >= amountFreeProduct) {
        if ($(".cart-item").hasClass("gb-find-remove-product")) {
          console.log("Free product already in cart");
        } else {
          console.log("Adding free product");
          $(".gb-free-product-trigger").trigger("click");
        }
      } else {
        console.log("Removing free product - under threshold");
        $(".gb-remove-product").trigger("click");
      }
    }, 3000);
    $("body").on("click", ".gb-sumbit-free", function () {
      setTimeout(function () {
        if (cart_total >= amountFreeProduct) {
          if ($(".cart-item").hasClass("gb-find-remove-product")) {
          } else {
            $(".gb-free-product-trigger").trigger("click");
          }
        } else {
          $(".gb-remove-product").trigger("click");
        }
      }, 3000);
    });

    // $("body").on("click", ".shop-add-to-cart-button", function () {
    //   setTimeout(function () {
    //     var cart_total = $(".gb-totals-total-value").first().text();
    //     if (cart_total >= amount_free_product) {
    //       if ($(".cart-item").hasClass("gb-find-remove-product")) {
    //       } else {
    //         $(".gb-free-product-trigger").trigger("click");
    //       }
    //     } else {
    //       $(".gb-remove-product").trigger("click");
    //     }
    //   }, 3000);
    // });
  }

  $("body").on("click", ".gb-shipping-protection-button label.switch", async (e) => {
    if (e.target.tagName == "INPUT") return;
    const curElem = document.querySelector(".gb-shipping-protection-button label.switch");
    const curInputElem = document.querySelector(".gb-shipping-protection-button label.switch input");
    const spinAnim = document.querySelector(".gb-shipping-protection-button .spin-animation");
    const checkElem = document.querySelector(".gb-shipping-protection-button .complete-check");
    if (curElem.classList.contains("unchecked") && !curInputElem.checked) {
      if (spinAnim.style.display == "block" || curInputElem.checked) return;

      // $(".gb-product-shipping-protection-product-tirgger").trigger("click");
      const form = document.querySelector("form.shipping-protection-form");

      const formData = new FormData(form);
      if (!formData.get("id")) {
        console.error(
          "There is no shipping protection product selected. Please select the shipping product in the global theme settings",
        );
        return;
      }

      spinAnim.style.display = "block";

      try {
        const response = await fetch(routes.cart_add_url, {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (response.ok) {
          spinAnim.style.display = "none";

          checkElem.style.display = "block";
        }
      } catch (err) {
        console.error("error at shipping protection form submission", err);
      }
      fetch(routes.cart_url + "?view=drawer")
        .then((response) => response.text())
        .then((html) => {
          const cartDrawer = document.querySelector("#CartDrawer");
          const parsedCartHtml = parser.parseFromString(html, "text/html");
          const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
          if (cartDrawer && newCartDrawer) {
            updateCartDrawer(cartDrawer, newCartDrawer, true, () => {
              curElem.classList.remove("unchecked");
              curElem.classList.add("checked");
              curInputElem.checked = true;
            });
          }
        })
        .catch((_err) => {
          curElem.classList.remove("unchecked");
          curElem.classList.add("checked");
          curInputElem.checked = true;
        });
    } else if (curElem.classList.contains("checked") && curInputElem.checked) {
      checkElem.style.display = "none";
      const cartDrawer = document.querySelector("#CartDrawer");
      const removeButton = cartDrawer.querySelector(`cart-remove-button[data-id="${shippingProductId}"]`);
      const shippingItemIndex = removeButton?.dataset.index;
      if (!removeButton || !shippingItemIndex) {
        return;
      }

      const cartItems = cartDrawer.querySelector("cart-items") || cartDrawer.querySelector("cart-drawer-items");

      const event = new CustomEvent("remove-shipping-protection", {
        detail: null,
      });
      cartItems.updateQuantity(shippingItemIndex, 0, event, "", "", () => {
        curElem.classList.remove("checked");
        curElem.classList.add("unchecked");
        curInputElem.removeAttribute("checked");
      });
    }
  });

  $("body").on("change", ".gb-change-variant_id", function () {
    var id_change = $(this).find(":selected").attr("data-variant-id");
    if (!id_change) {
      console.error("No data-variant-id found on selected option");
      return;
    }
    $(this).closest(".gb-get-main-freq-pro").find(".product-variant-id").val(id_change);
  });
});

document.addEventListener("change", function (e) {
  if (e.target.matches(".cart-drawer .gbfrequently-bought-with-main-whole .select__select")) {
    const parentBlock = e.target.closest(".gb-get-main-freq-pro");
    if (!parentBlock) {
      console.log("Error: Could not find parent block");
      return;
    }

    const allValues = Array.from(parentBlock.querySelectorAll(".select__select"))
      .map((sel) => sel.value)
      .join(" / ");

    const variantSelect = parentBlock.querySelector('[name="variants"]');
    if (!variantSelect) {
      console.log("Error: Could not find variant selector");
      return;
    }

    const matchedOption = Array.from(variantSelect.options).find((option) => option.text.includes(allValues));

    const idInput = parentBlock.querySelector('[name="id"]');
    if (!idInput) {
      console.log("Error: Could not find id input field");
      return;
    }

    if (matchedOption) {
      console.log("Matched variant option value:", matchedOption.value);
      idInput.value = matchedOption.value;
      console.log("Set ID input value to:", idInput.value);
    } else {
      console.log("No matching variant found for:", allValues);
    }
  }
});

// Add validation for form submissions to ensure ID parameter is present
document.addEventListener("submit", function (e) {
  if (e.target.action && e.target.action.includes("/cart/add")) {
    const idInput = e.target.querySelector('[name="id"]');
    if (!idInput || !idInput.value) {
      console.log("Preventing submission - missing id parameter");
      e.preventDefault();
      return false;
    }
  }
});

// Improve cart quantity handlers
$(document).ready(function () {
  // Ensure all cart quantity changes include product ID
  $(".cart-item .quantity__button, .cart-item .quantity__input").on("click change input", function () {
    const cartItem = $(this).closest(".cart-item");
    const variantId = $(this).closest(".quantity-input").find(".quantity__input").data("quantity-variant-id");

    // If this is a form submission, ensure the ID is included
    if ($(this).closest("form").length > 0) {
      let idInput = $(this).closest("form").find('input[name="id"]');
      if (idInput.length === 0 && variantId) {
        console.log("Adding missing ID input to cart form");
        $("<input>")
          .attr({
            type: "hidden",
            name: "id",
            value: variantId,
          })
          .appendTo($(this).closest("form"));
      } else if (idInput.length > 0 && variantId) {
        idInput.val(variantId);
      }
    }
  });

  // Add validation for cart drawer checkout button
  $("#CartDrawer-Checkout").on("click", function (e) {
    const form = $("#CartDrawer-Form");
    if (form.length === 0) return;

    // Check if there are any items in the cart
    const cartItems = form.find(".cart-item");
    if (cartItems.length === 0) {
      console.log("No items in cart, preventing checkout");
      e.preventDefault();
      return false;
    }

    console.log("Cart checkout with", cartItems.length, "items");
  });

  /**
   * * Prevent redirecting to checkout when pressing enter at quantity input
   */
  $(document).on("keydown", ".quantity__input", function (e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      $(this).trigger("blur");
    }
  });
  // * End of handler
});

// Fix for frequently bought products add to cart
$(document).ready(function () {
  // Find all frequently bought product forms or buttons
  $(
    ".gbfrequently-bought-with-main-whole button, .gbfrequently-bought-with-main-whole .gb-sumbit-free, .gb-free-product-trigger, .gb-product-shipping-protection-product-tirgger, .gb-product-sticky-add-to-cart-form",
  ).on("click", function (e) {
    const parentBlock = $(this).closest(".gb-get-main-freq-pro, form");
    if (!parentBlock) {
      console.error("Could not find parent block for frequently bought product");
      return;
    }

    // Find the product ID input or data attribute
    let productId = null;

    // Check for direct ID input
    const idInput = parentBlock.find('input[name="id"]');
    if (idInput.length > 0 && idInput.val()) {
      productId = idInput.val();
    }
    // Check for variant ID on select
    else if (parentBlock.find(".gb-change-variant_id").length > 0) {
      const selectedOption = parentBlock.find(".gb-change-variant_id option:selected");
      if (selectedOption.length > 0) {
        productId = selectedOption.data("variant-id");
      }
    }
    // Check for product-variant-id input
    else if (parentBlock.find(".product-variant-id").length > 0) {
      productId = parentBlock.find(".product-variant-id").val();
    }
    // Check for data attributes on the button itself
    else if ($(this).data("variant-id")) {
      productId = $(this).data("variant-id");
    }

    console.log("Frequently bought product add to cart - ID:", productId);

    if (this.classList.contains("gb-free-product-trigger") && !show_progress_bar) return;

    // If no product ID found, prevent submission
    if (!productId) {
      console.error("Missing product ID for frequently bought product");
      e.preventDefault();
      return false;
    }

    // Update or create the ID input
    if (idInput.length === 0) {
      console.log("Adding missing ID input to frequently bought product form");
      $("<input>")
        .attr({
          type: "hidden",
          name: "id",
          value: productId,
        })
        .appendTo(parentBlock);
    } else {
      idInput.val(productId);
    }

    // Ensure quantity is included
    let quantityInput = parentBlock.find('input[name="quantity"]');
    if (quantityInput.length === 0) {
      console.log("Adding default quantity input to frequently bought product form");
      $("<input>")
        .attr({
          type: "hidden",
          name: "quantity",
          value: 1,
        })
        .appendTo(parentBlock);
    } else if (!quantityInput.val() || quantityInput.val() < 1) {
      quantityInput.val(1);
    }
  });
});



/* Auto-add shipping protection (pre-checked) when the cart opens */
(function () {
  var FLAG = "kachingShippingProtectionAutoAdded";
  var timer = null;
  var observer = null;
  function done() {
    try { return !!sessionStorage.getItem(FLAG); } catch (e) { return false; }
  }
  function tryAutoAdd() {
    timer = null;
    if (done()) { if (observer) observer.disconnect(); return; }
    var drawer = document.querySelector('kaching-cart-drawer[open="true"]');
    if (!drawer || !drawer.querySelector(".kaching-cart-item")) return;
    var toggle = drawer.querySelector(".kaching-upsell-toggle-item__toggle-container .kaching-cart-toggle");
    if (!toggle || toggle.disabled || toggle.classList.contains("kaching-cart-toggle__disabled")) return;
    try { sessionStorage.setItem(FLAG, "1"); } catch (e) {}
    if (observer) observer.disconnect();
    if (toggle.classList.contains("kaching-cart-toggle__active")) return;
    toggle.click();
  }
  if (done()) return;
  observer = new MutationObserver(function () {
    if (!timer) timer = setTimeout(tryAutoAdd, 800);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ["open", "class", "disabled"] });
})();


/* Vamora Learning App: show at the bottom of the cart, hide savings badge, add description */
(function () {
  var SEL = '.kaching-cart-item[data-product-handle="vip-membership"]';
  var LINES = [
    "Learn new words and save their meanings.",
    "Fun quizzes, XP, stars, and challenges.",
    "Track reading progress and earn certificates.",
    "Win a FREE limited-edition Vamora Kids book!"
  ];
  var css = document.createElement("style");
  css.textContent =
    ".kaching-cart__module:has(> .kaching-cart-item-container){display:flex;flex-direction:column}" +
    ".kaching-cart-item-container:has(> " + SEL + "){order:999}" +
    SEL + " .kaching-cart__badge{display:none!important}" +
    ".vam-app-desc{list-style:none;margin:6px 0 4px;padding:0;font-size:12px;line-height:1.45;opacity:.85}" +
    ".vam-app-desc li{margin:0;padding:0}" +
    ".vam-app-desc li:before{content:'\\2713';color:#2e9d5b;font-weight:700;margin-right:6px}";
  document.head.appendChild(css);
  function addDescriptions() {
    var items = document.querySelectorAll(SEL);
    for (var i = 0; i < items.length; i++) {
      var info = items[i].querySelector(".kaching-cart-item__info");
      if (!info || info.querySelector(".vam-app-desc")) continue;
      var ul = document.createElement("ul");
      ul.className = "vam-app-desc";
      for (var j = 0; j < LINES.length; j++) {
        var li = document.createElement("li");
        li.textContent = LINES[j];
        ul.appendChild(li);
      }
      info.appendChild(ul);
    }
  }
  var timer = null;
  new MutationObserver(function () {
    if (!timer) timer = setTimeout(function () { timer = null; addDescriptions(); }, 100);
  }).observe(document.documentElement, { childList: true, subtree: true });
  addDescriptions();
})();

/* Cart add-on cards: blue style with labels */
(function () {
  var I = ".kaching-product-upsell-item";
    var css = document.createElement("style");
      css.textContent =
          ".kaching-upsell-module--product-upsell .kaching-cart-product-upsell-carousel__title{display:none!important}" +
              ".kaching-cart-carousel-item-layout-3{display:flex!important;flex-direction:column;gap:12px}" +
                  I + "{display:grid!important;grid-template-columns:96px 1fr;grid-template-areas:'lbl lbl' 'img title' 'img price' 'btn btn';column-gap:14px;row-gap:6px;align-items:start;background:#fff;border:1.5px solid #bcd3f5;border-radius:14px;padding:14px;margin:0!important;box-shadow:0 2px 8px rgba(30,58,138,.06);text-align:left}" +
                      I + "[data-product-handle='vamora-who-knows-me-better-family-card-game']{border-color:#2f6fd6;background:#f3f8ff}" +
                          I + ":before{grid-area:lbl;font-size:12px;font-weight:800;letter-spacing:.06em;color:#1e4fa8;text-transform:uppercase;margin-bottom:4px}" +
                              I + "[data-product-handle='vamora-who-knows-me-better-family-card-game']:before{content:'\\25CF  Never Been This Cheap'}" +
                                  I + "[data-product-handle='little-reader-s-bookmark']:before{content:'\\25CF  Recommended Add-On'}" +
                                      I + "__image-container>a{display:block;width:100%;height:100%}" +
                                          I + "__image-container{grid-area:img;grid-row:2 / span 2;width:96px!important;height:96px!important;max-width:none!important;flex:none!important;background:#e8f0fd;border-radius:10px;overflow:hidden;display:flex;align-items:center;justify-content:center}" +
                                              I + "__image{width:100%!important;height:100%!important;max-width:none!important;max-height:none!important;object-fit:cover}" +
                                                  I + "__content{display:contents!important}" +
                                                      I + "__title{grid-area:title;font-size:15px!important;font-weight:700!important;line-height:1.3;color:#0f1f3d!important;text-decoration:none}" +
                                                          I + "__price-container{grid-area:price;justify-content:flex-start!important}" +
                                                              I + "__price-final{font-size:20px!important;font-weight:800!important;color:#0f1f3d!important}" +
                                                                  I + "__footer{grid-area:btn;margin-top:6px;width:100%}" +
                                                                      I + "__add-to-cart{width:100%!important;background:linear-gradient(90deg,#1e4fa8,#2f6fd6)!important;color:#fff!important;border:0!important;border-radius:10px!important;padding:13px 16px!important;font-size:15px!important;font-weight:700!important;cursor:pointer}" +
                                                                          I + "__add-to-cart:before{content:'+ '}";
                                                                            document.head.appendChild(css);
                                                                            })();
                                                                            
                                                                            /* Vamora Learning App: hide original price */
                                                                            (function () {
                                                                              var s = document.createElement("style");
                                                                                s.textContent = '.kaching-cart-item[data-product-handle="vip-membership"] .kaching-cart-item__total-old{display:none!important}';
                                                                                  document.head.appendChild(s);
                                                                                  })();
                                                                                  